<script setup>
import Services from '../services'
import { useField } from 'vee-validate'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps(['field', 'modelValue'])

const { value: model } = useField(
  () => props.field.clean_name,
  { required: props.field.required },
  {
    syncVModel: true,
  }
)

const options = props.field.choices?.length
  ? props.field.choices?.split('\r\n')
  : []

const clearModel = () => {
  model.value = Services.fieldDefaults[props.field.field_type]
}
</script>

<template>
  <div class="columns is-mobile is-vcentered is-gapless mb-0">
    <div class="column is-6-tablet">
      <template v-if="field.field_type == 'dropdown'">
        <b-dropdown v-model="model" aria-role="list" expanded>
          <template #trigger>
            <b-button
              :label="model || field.placeholder || t('apply.select')"
              icon-right="caret-down-bold"
              size="is-large"
              class="is-size-6"
              :class="{ 'has-text-grey-dark': !model?.length }"
              expanded
            />
          </template>

          <b-dropdown-item v-for="item in options" :value="item">
            {{ item }}
          </b-dropdown-item>
        </b-dropdown>

        <input type="hidden" :name="field.clean_name" :value="model" />
      </template>

      <b-dropdown
        v-model="model"
        aria-role="list"
        expanded
        v-if="field.field_type == 'multiselect'"
      >
        <template #trigger>
          <b-button
            :label="
              model.length
                ? model.join(', ')
                : field.placeholder || t('apply.select')
            "
            icon-right="caret-down-bold"
            size="is-large"
            class="is-size-6"
            :class="{ 'has-text-grey-dark': !model?.length }"
            expanded
          />
        </template>

        <b-dropdown-item custom aria-role="listitem" v-for="item in options">
          <b-checkbox
            v-model="model"
            :name="field.clean_name"
            :native-value="item"
          >
            {{ item }}
          </b-checkbox>
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="column is-narrow ml-3" v-if="!props.field.required && model">
      <b-button
        icon-left="x"
        type="is-light"
        class="is-square has-radius-small is-size-5"
        @click="clearModel"
      ></b-button>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
